import { Types } from './actions';

export const INITIAL_STATE = [];

export default function menuBlacklist(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case Types.SUCCESS: {
      return [...state, ...action.data];
    }
    default:
      return state;
  }
}
